import { useAppSelector } from 'src/app/hooks';
import { selectMap3dDataset } from 'src/map-3d/shared/map-3d-slices';
import { Map3DNoTerrainSelected } from '../../shared';
import { TabSwitcher } from '@aus-platform/design-system';

import { useState } from 'react';
import { AssessmentTabs } from './constants';
import { ComplianceAssessmentTabs } from './compliance-assessment-tabs';

export const ComplianceAssessmentSidecard: React.FC = () => {
  // useStates.
  const [activeTabKey, setActiveTabKey] = useState(AssessmentTabs.Generate);

  // Selectors.
  const { selectedTerrainIteration } = useAppSelector(selectMap3dDataset);

  // Renders.
  if (!selectedTerrainIteration?.id) {
    return <Map3DNoTerrainSelected />;
  }

  // Handlers.
  const handleTabChange = (activeTabKey: string) => {
    setActiveTabKey(activeTabKey);
  };

  return (
    <div className="compliance-assessment__container">
      <TabSwitcher
        tabComponentList={ComplianceAssessmentTabs({
          activeTabKey,
          setActiveTabKey,
        })}
        activeKey={activeTabKey}
        onTabSwitch={handleTabChange}
      />
    </div>
  );
};
